import { Tag, TagMatchType } from ".";

export class Day {
    private _dayName: string;
    private _dayOfWeek: number;
    private _times: Tag[];

    public get dayName(): string {
        return this._dayName;
    }

    public get dayOfWeek(): number {
        return this._dayOfWeek;
    }

    public get times(): Tag[] {
        return this._times;
    }

    public toString(): string {
        const timeNames = this._times
            .sort((a, b) => a.tagId - b.tagId)
            .map(t => t.tagName.replace(this._dayName, ""));

        return `${this._dayName} - ${timeNames.join(" • ")}`;
    }

    public isIn = (arr: { dayName: string }[]): boolean => {
        arr = arr != null ? arr : [];
        return arr.findIndex(d => d.dayName === this.dayName) >= 0;
    };

    private constructor(dayName: string, times: Tag[]) {
        this._dayName = dayName;
        this._times = times;
    }

    public static Monday = new Day("Monday", [
        Tag.MondayMornings,
        Tag.MondayAfternoons,
        Tag.MondayEvenings,
    ]);
    public static Tuesday = new Day("Tuesday", [
        Tag.TuesdayMornings,
        Tag.TuesdayAfternoons,
        Tag.TuesdayEvenings,
    ]);
    public static Wednesday = new Day("Wednesday", [
        Tag.WednesdayMornings,
        Tag.WednesdayAfternoons,
        Tag.WednesdayEvenings,
    ]);
    public static Thursday = new Day("Thursday", [
        Tag.ThursdayMornings,
        Tag.ThursdayAfternoons,
        Tag.ThursdayEvenings,
    ]);
    public static Friday = new Day("Friday", [
        Tag.FridayMornings,
        Tag.FridayAfternoons,
        Tag.FridayEvenings,
    ]);

    public static create(dayName: string, times: Tag[]) {
        return new Day(dayName, times);
    }

    public static asArray = (): Day[] => [
        Day.Monday,
        Day.Tuesday,
        Day.Wednesday,
        Day.Thursday,
        Day.Friday,
    ];

    public static fromDayName = (dayName: string): Day =>
        Day.asArray().find(d => d.dayName === dayName);

    public static fromTags = (tagMatchTypes: TagMatchType[]): Day[] => {
        const days = Day.asArray();
        const daysFromTags: Day[] = [];

        tagMatchTypes.forEach(tagMatchType => {
            days.forEach(day => {
                if (
                    day.times.findIndex(t => t.tagId === tagMatchType.tagId) >=
                    0
                ) {
                    const tagDaysIndex = daysFromTags.findIndex(
                        td => td.dayName === day.dayName
                    );
                    if (tagDaysIndex < 0) {
                        const tagDay = Day.create(day.dayName, [
                            Tag.fromId(tagMatchType.tagId),
                        ]);
                        daysFromTags.push(tagDay);
                    } else {
                        daysFromTags[tagDaysIndex].times.unshift(
                            Tag.fromId(tagMatchType.tagId)
                        );
                    }
                }
            });
        });

        // now have all days
        return daysFromTags;
    };
}
